@if (loadingService.loadingIndicator$ | async) {
  <div class="loader"></div>
}
